import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const ELNurl = window.appUrl.ELN;

const ProtocolFileDownload = () => {
  const location = useLocation();
  const [downloadStatus, setDownloadStatus] = useState("downloading"); 

  useEffect(() => {
    const downloadFile = async () => {
      try {
        const params = new URLSearchParams(location.search);

        const tenantid = params.get("tenantid");
        const screen = params.get("screen");
        const filetype = params.get("filetype") || params.get("type");
        const protocolname = params.get("protocolname");
        const sectionname = params.get("sectionname");
        const stepname = params.get("stepname");
        const editorname = params.get("editorname");
        const filename = params.get("filename");
        const extension = params.get("extension");

        if (!tenantid || !protocolname || !filename || !extension) {
          alert("Missing required parameters in URL");
          return;
        }

        let apiUrl = "";

        if (sectionname && stepname && editorname) {
          apiUrl = `${ELNurl}/protocol/downloadprotocolfilewithstepname/${tenantid}/${screen}/${filetype}/${protocolname}/${sectionname}/${stepname}/${editorname}/${filename}/${extension}`;
        } else {
          apiUrl = `${ELNurl}/protocol/downloadprotocolfilewithoutstepname/${tenantid}/${screen}/${filetype}/${protocolname}/${filename}/${extension}`;
        }

        console.log("Downloading from:", apiUrl);

        const response = await axios.get(apiUrl, {
          responseType: "blob",
          headers: {
            "X-TenantID": tenantid,
          },
        });

        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/octet-stream",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename + extension;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setDownloadStatus("success");

        // setTimeout(() => window.close(), 1500);
      } catch (error) {
        console.error("Download failed:", error);
        setDownloadStatus("error");
      }
    };

    downloadFile();
  }, [location.search]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px", fontFamily: "Arial" }}>
      {downloadStatus === "downloading" && (
        <>
          <h3>Downloading your file...</h3>
          <p>If the download doesn’t start automatically, please check your pop-up settings.</p>
        </>
      )}

      {downloadStatus === "success" && (
        <>
          <h3>✅ File downloaded successfully!</h3>
          <p>You can now close this tab.</p>
        </>
      )}

      {downloadStatus === "error" && (
        <>
          <h3>❌ Download failed.</h3>
          <p>Please check your details or connection and try again.</p>
        </>
      )}
    </div>
  );
};

export default ProtocolFileDownload;
